var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('add-to-cart-base',{attrs:{"id":_vm.id},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var addItem = ref.addItem;
return [_c('button',{staticClass:"btn btn-primary",on:{"click":addItem}},[_vm._v("\n            "+_vm._s(_vm.__('Add'))+"\n            "),_c('i',{staticClass:"fa fa-cart"})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }